// src/components/Common/StatusBadge.jsx
import React from 'react';

const statusConfig = {
  draft: {
    label: 'Draft',
    className: 'bg-gray-100 text-gray-600',
  },
  pending: {
    label: 'Pending',
    className: 'bg-yellow-100 text-yellow-700',
  },
  approved: {
    label: 'Approved',
    className: 'bg-green-100 text-green-700',
  },
  rejected: {
    label: 'Rejected',
    className: 'bg-red-100 text-red-700',
  },
  cancelled: {
    label: 'Cancelled',
    className: 'bg-gray-100 text-gray-500',
  },
  withdrawn: {
    label: 'Withdrawn',
    className: 'bg-orange-100 text-orange-700',
  },
  expired: {
    label: 'Expired',
    className: 'bg-gray-200 text-gray-600',
  },
  closed: {
    label: 'Closed',
    className: 'bg-blue-100 text-blue-700',
  },
};

const StatusBadge = ({ status, className = '' }) => {
  const config = statusConfig[status] || {
    label: status || 'Unknown',
    className: 'bg-gray-100 text-gray-600',
  };

  return (
    <span
      className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${config.className} ${className}`}
    >
      {config.label}
    </span>
  );
};

export default StatusBadge;